import { createContext, useContext, useState } from "react";

const HoverContext = createContext();

export function HoverProvider({ children }) {
  const [hoverNodeId, setHoverNodeId] = useState(null);
  return (
    <HoverContext.Provider value={{ hoverNodeId, setHoverNodeId }}>
      {children}
    </HoverContext.Provider>
  );
}

export const useHover = () => useContext(HoverContext);
